﻿import React, { useEffect, useState, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Postrequestcall } from "../../request/Postrequest";
import { useSelector } from "react-redux";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardMedia,
  Grid,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Tab,
  Tabs,
  useMediaQuery,
  useTheme
} from "@mui/material";
import PlaceholderImg from "../../assets/images/placeholder_img.jpg";
import PictureViewer from "../common/PictureViewer";
import { BIRed } from "../../assets/helpers";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Loader from "../../common/Loader";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ProjectAboutSection from "./ProjectAboutSection";
import {
  FETCH_FOLLOW_ENTITIES,
  FETCH_POST_PICTURES,
  FETCH_PROJECT_MEMBERS,
  FETCH_PROJECTS_FAVOURITE_IMAGES,
  FETCH_PROJECTS_POSTS_PICTURES_FOR_WEB,
  FETCH_USER_SITES_PROJECTS,
  FETCH_USERS_SITES_PROJECTS_FOR_WEB,
  SAVE_FOLLOW_ENTITIES,
  SAVE_POST_PICTURE,
  SAVE_POSTS
} from "../../constant/Apipath";
import { Getrequestcall } from "../../request/Getrequest";
import DeleteConfirmation from "../common/DeleteConfirmation";
import ProjectPhotosSection from "./ProjectPhotosSection";
import ProjectCompanySection from "./ProjectCompaniesSection";
import ProjectProductSection from "./ProjectProductSection";
import ProjectPostsSection from "./ProjectPostsSection";
import SendInChatModal from "../common/SendInChatModal";
import NoSuchPage from "../common/NoSuchPage";
import { SignInCard } from "../common/SignInCard";
import { useDispatch } from "react-redux";
import {
  setCommunityPostIds,
  setSelectedProjectdata,
  setShowaddexperience,
  setShowReport
} from "../../redux/actions/actions";
import MemberList from "../common/MemberList";
import { English } from "../../constant/EnglishFallback";
import Pageheader from "../common/Pageheader";
import Pages from "../../constant/ReportModel";

const ProjectProfile = () => {
  let scrollTargetId = "scrollablediv_prodcut";
  let { id } = useParams();
  const { pathname } = useLocation();
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const LanguageData = multiLanguageData?.Projects || {};
  const {
    TEXT_PROJECTS = English.Projects.TEXT_PROJECTS,
    TEXT_PROJECT = English.Projects.TEXT_PROJECT,
    TEXT_ADD_TO_PROFILE = English.Projects.TEXT_ADD_TO_PROFILE,
    BUTTON_UNFOLLOW = English.Projects.BUTTON_UNFOLLOW,
    BUTTON_FOLLOW = English.Projects.BUTTON_FOLLOW,
    BUTTON_POSTS = English.Projects.BUTTON_POSTS,
    BUTTON_PHOTOS = English.Projects.BUTTON_PHOTOS,
    TEXT_COMPANIES = English.Projects.TEXT_COMPANIES,
    TEXT_PRODUCTS = English.Projects.TEXT_PRODUCTS,
    BUTTON_ADD_PROJECT_PICTURE = English.Projects.BUTTON_ADD_PROJECT_PICTURE,
    BUTTON_SEND_IN_CHAT = English.Projects.BUTTON_SEND_IN_CHAT,
    BUTTON_SHARE = English.Projects.BUTTON_SHARE,
    BUTTON_REPORT = English.Projects.BUTTON_REPORT,
    TEXT_UNFOLLOW_PROJECT_PAGE = English.Projects.TEXT_UNFOLLOW_PROJECT_PAGE,
    TEXT_DELETE_MODAL_DESC2 = English.Projects.TEXT_DELETE_MODAL_DESC2,
    TEXT_YES = English.Projects.TEXT_YES,
    BUTTON_REMOVE = English.Projects.BUTTON_REMOVE
  } = LanguageData || {};

  const isAndroid = /Android/i.test(navigator.userAgent);
  const isIphone = /iPhone/i.test(navigator.userAgent);
  const isIpad = /iPad/i.test(navigator.userAgent);

  const [projectData, setProjectData] = useState({
    projectDetails: null,
    memberList: [],
    pictureList: [],
    followDetails: null
  });

  const [activeTab, setActiveTab] = useState("posts");
  const [showLoader, setShowLoader] = useState(true);
  const [showImagePreview, setShowImagePreview] = useState(false);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [showConformationModal, setShowConformationModal] = useState(null);
  const [showFollowLoader, setShowFollowLoader] = useState(false);
  const [imageDataLoading, setImageDataLoading] = useState(true);
  const [showMemberList, setShowMemberList] = useState(false);
  const [showMemberBtnLoader, setShowMemberBtnLoader] = useState(false);
  const [showSendInChatModal, setShowSendInChatModal] = useState(false);
  const [noSuchData, setNoSuchData] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const mainTabMenuList = [
    { label: "posts", translateLabel: BUTTON_POSTS },
    { label: "photos", translateLabel: BUTTON_PHOTOS },
    { label: "companies", translateLabel: TEXT_COMPANIES },
    { label: "products", translateLabel: TEXT_PRODUCTS }
  ];

  const moreMenuList = [
    { label: "Add Project Picture", translateLabel: BUTTON_ADD_PROJECT_PICTURE },
    { label: "Send in Chat", translateLabel: BUTTON_SEND_IN_CHAT },
    { label: "Share", translateLabel: BUTTON_SHARE },
    { label: "Report", translateLabel: BUTTON_REPORT }
  ];

  useEffect(() => {
    if (pathname.includes("proxySite")) {
      getProxyPageData();
    } else if (id) {
      getData();
    }
  }, [id]);

  // Proxy sites start

  const getProxyPageData = async () => {
    setShowLoader(true);
    try {
      const [projectDetails, pictureList] = await Promise.all([
        fetchProjectDetailsForWeb().catch((e) => null), // handle errors individually
        fetchPicturesForWeb().catch((e) => null)
      ]);

      setProjectData({
        projectDetails,
        pictureList
      });
      openInPhone();
    } catch (error) {
      console.log("getProxyPageData-> Error While Getting Project Data: ", error);
    } finally {
      setShowLoader(false);
    }
  };

  function openInPhone() {
    if (isAndroid) {
      const androidUrl = `intent://?screenName=${"ProjectPage"}&id=${id}#Intent;scheme=mybuilderid;package=com.mybuilderid;end`;
      window.location.replace(androidUrl);
    } else if (isIphone || isIpad) {
      const iPhoneUrl = `mybuilderid://?screenName=${"ProjectPage"}&id=${id}`;
      window.location.replace(iPhoneUrl);
    }
  }

  const fetchProjectDetailsForWeb = async () => {
    try {
      const obj = {
        SearchList: [{ Id: id }]
      };
      const res = await Postrequestcall(FETCH_USERS_SITES_PROJECTS_FOR_WEB, obj, undefined);
      let resData = res?.data?.data?.[0] ?? null;
      setNoSuchData(resData ? false : true);
      return resData;
    } catch (error) {
      console.log("fetchProjectDetailsForWeb-> Error When Fetching User Site Project: ", error);
    }
  };

  const fetchPicturesForWeb = async () => {
    try {
      const postObj = {
        SearchList: [{ appRecordId: id }],
        SortList: [{ FieldName: "Id", Direction: "DESC" }]
      };
      const projectPostPicturesRes = await Postrequestcall(
        FETCH_PROJECTS_POSTS_PICTURES_FOR_WEB,
        postObj,
        undefined
      );
      let projectPostPicturesData = projectPostPicturesRes?.data?.data ?? [];
      return projectPostPicturesData;
    } catch (error) {
      console.error("fetchPicturesForWeb-> Error While Fetching Project Post Picture: ", error);
    }
  };

  // Proxy sites end
  const getData = async () => {
    setShowLoader(true);
    try {
      const [projectDetails, pictureList, memberList, followDetails] = await Promise.all([
        fetchProjectDetails().catch((e) => null), // handle errors individually
        fetchPictures().catch((e) => null),
        fetchProjectMembers().catch((e) => null),
        fetchFollowsEntity().catch((e) => [])
      ]);
      setProjectData({
        projectDetails,
        pictureList,
        memberList,
        followDetails
      });
    } catch (error) {
      console.log("getData-> Error While Fetching All Data Of Project: ", error);
    } finally {
      setShowLoader(false);
    }
  };

  const fetchProjectDetails = async () => {
    try {
      const obj = {
        SearchList: [{ Id: id }]
      };
      const res = await Postrequestcall(FETCH_USER_SITES_PROJECTS, obj, loginData?.accessToken);
      let resData = res?.data?.data?.[0] ?? null;
      setNoSuchData(resData ? false : true);
      return resData;
    } catch (error) {
      console.log("fetchProjectDetails-> Error When Fetching User Site Project: ", error);
    }
  };

  const fetchPictures = async () => {
    try {
      const postObj = {
        PageNr: 1,
        NrOfRecPerPage: 100,
        FullSearch: "",
        UserId: currentUserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [{ appRecordId: id }],
        SortList: [{ FieldName: "Id", Direction: "DESC" }]
      };
      const projectPostPicturesRes = await Postrequestcall(
        FETCH_POST_PICTURES,
        postObj,
        loginData?.accessToken
      );
      let projectPostPicturesData = projectPostPicturesRes?.data?.data ?? [];
      const projectFavImagesRes = await Postrequestcall(
        FETCH_PROJECTS_FAVOURITE_IMAGES,
        postObj,
        loginData?.accessToken
      );
      let projectFavImagesData = projectFavImagesRes?.data?.data ?? [];
      const favoritePictureIds = new Set(projectFavImagesData?.map((img) => img.projectPictureId));
      const projectWithFavImages = projectPostPicturesData?.map((fav) => ({
        ...fav,
        isFavorite: favoritePictureIds.has(fav.pictureId)
      }));
      setImageDataLoading(false);
      return projectWithFavImages;
    } catch (error) {
      setImageDataLoading(false);
      console.error("fetchPictures-> Error While Fetching Images: ", error);
    }
  };

  const fetchFollowsEntity = async () => {
    try {
      const obj = {
        SearchList: [
          {
            EntityId: Number(id),
            userId: currentUserId
          }
        ]
      };

      const res = await Postrequestcall(FETCH_FOLLOW_ENTITIES, obj, loginData?.accessToken);
      let resData = res?.data?.data?.[0] ?? null;
      return resData;
    } catch (error) {
      console.log("fetchFollowsEntity-> Error While Fetching Follow Entities: ", error);
    }
  };

  const fetchProjectMembers = async () => {
    try {
      const res = await Getrequestcall(
        `${FETCH_PROJECT_MEMBERS}/${currentUserId}/${id}`,
        loginData?.accessToken
      );
      let resData = res?.data?.data ?? [];
      return resData;
    } catch (error) {
      console.log("fetchProjectMembers-> Error While Fetching Project Member: ", error);
    }
  };

  const getUpdatedPhotos = async () => {
    setImageDataLoading(true);
    try {
      const resData = await fetchPictures();
      setProjectData((prevData) => ({
        ...prevData,
        pictureList: resData ?? null
      }));
    } catch (error) {
      console.error("getUpdatedPhotos-> Error While Fething Pictures: ", error);
    } finally {
      setImageDataLoading(false);
    }
  };

  let isSharing = false;
  const onShareClick = async () => {
    if (navigator.share) {
      if (isSharing) return;

      const shareData = {
        title: "Manufacture Profile",
        url: window.location.href
      };

      isSharing = true;
      navigator
        .share(shareData)
        .catch((error) => console.error("isSharing-> Error In Navigator While Sharing: ", error))
        .finally(() => {
          isSharing = false;
        });
    } else {
      try {
        try {
          await navigator.clipboard.writeText(window.location.href);
        } catch (err) {
          const textArea = document.createElement("textarea");
          textArea.value = window.location.href;
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.body.removeChild(textArea);
        }
        alert("Link copied to clipboard");
        isSharing = false;
      } catch (error) {
        console.log("isSharing-> Error In Navigator While Sharing (fallback): ", error);
      }
    }
  };

  const onSendChatClick = () => {
    setShowSendInChatModal(true);
  };

  const changeFollowStatus = async (isFollow) => {
    try {
      setShowFollowLoader(true);
      const obj = {
        UserId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: projectData?.followDetails?.id,
            EntityTypeId: 24,
            EntityId: Number(id),
            UserId: Number(currentUserId),
            IsFollowing: isFollow,
            ModifiedBy: Number(currentUserId)
          }
        ]
      };
      await Postrequestcall(SAVE_FOLLOW_ENTITIES, obj, loginData?.accessToken);
      // After follow projects clear the community post redux 
      const grouped = {
        all: [],
        products: [],
        projects: [],
        trades: []
      };
      dispatch(setCommunityPostIds(grouped));
      const [memberList, followDetails] = await Promise.all([
        fetchProjectMembers().catch((e) => []),
        fetchFollowsEntity().catch((e) => [])
      ]);
      setProjectData((preValue) => ({
        ...preValue,
        memberList,
        followDetails
      }));
      setShowFollowLoader(false);
    } catch (error) {
      setShowFollowLoader(false);
      console.log("changeFollowStatus-> Error When Chaging Follow Status: ", error);
    }
  };

  const addProjectToUserProfile = async () => {
    try {
      dispatch(
        setSelectedProjectdata({
          ...projectData?.projectDetails,
          mainPictureUrl: projectData?.pictureList[0]?.pictureUrl || "",
          projectId: projectData?.projectDetails?.id,
          siteName: projectData?.projectDetails?.name,
          address: projectData?.projectDetails?.address,
          from: "project-detail",
          followDetailsId: projectData?.followDetails?.id
        })
      );
      dispatch(setShowaddexperience(true));
    } catch (error) {
      console.log("addProjectToUserProfile-> Error When Adding Project To User Profile: ", error);
    }
  };

  const onProjectDetailsSaveSuccessfully = async () => {
    setShowLoader(true);
    try {
      const resData = await fetchProjectDetails();
      setProjectData((prevData) => ({
        ...prevData,
        projectDetails: resData ?? null
      }));
    } catch (error) {
      console.error("onProjectDetailsSaveSuccessfully-> Error When Fetching Project Data: ", error);
    } finally {
      setShowLoader(false);
    }
  };

  const handleFileSelect = async (e) => {
    let files = e.target.files;
    if (files && files.length > 0) {
      let allFilesValid = true;

      for (let i = 0; i < files.length; i++) {
        if (!files[i].type.startsWith("image/")) {
          allFilesValid = false;
          break;
        }
      }

      if (allFilesValid) {
        setImageDataLoading(true);
        const obj = {
          UserId: Number(currentUserId),
          ReturnRecordId: true,
          ReturnRecordError: false,
          SaveList: [
            {
              Id: 0,
              FormatTypeId: 1,
              PostedByUserId: Number(currentUserId),
              AppId: 24,
              AppRecordId: id,
              Message: "<<<picture>>>",
              Reported: false,
              ModifiedBy: Number(currentUserId)
            }
          ]
        };

        try {
          const postRes = await Postrequestcall(SAVE_POSTS, obj, loginData?.accessToken);

          for (let i = 0; i < files.length; i++) {
            const formData = new FormData();
            formData.append("Id", 0);
            formData.append("PostId", postRes?.data?.data?.[0]?.objData?.id ?? 0);
            formData.append("ModifiedBy", currentUserId);
            formData.append("Pictures", files[i]);

            await Postrequestcall(SAVE_POST_PICTURE, formData, loginData?.accessToken, "formData");
          }
          await getUpdatedPhotos();
          setActiveTab("photos");
          setImageDataLoading(false);
        } catch (err) {
          setImageDataLoading(false);
          console.log("handleFileSelect-> Error While Saving Pictures: ", err);
        }
      } else {
        alert("Please select valid image files (JPEG, PNG, GIF, etc.).");
      }
    }
    e.target.value = null;
  };

  const handleOpenReportModal = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      recordId: projectData?.projectDetails?.id,
      name: Pages?.projects?.name,
      AppScreenId: Pages?.projects?.id
    };
    dispatch(setShowReport(reportObj));
  };

  if (noSuchData) {
    return (
      <Stack style={{ width: "100%", minHeight: "200px", marginTop: "20px" }}>
        <NoSuchPage />
      </Stack>
    );
  }

  return (
    <>
      <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
        {showLoader ? (
          <Pageheader headerName={""} />
        ) : (
          <Pageheader headerName={projectData?.projectDetails?.projectName} />
        )}
        <Card className="main-content-card">
          {showLoader ? (
            <Loader />
          ) : (
            <Box className="main-content-card-list" id={scrollTargetId}>
              <Grid container spacing={1.5}>
                <Grid
                  size={{
                    xs: 12,
                    md: 12
                  }}>
                  <Card className="pagelist-content">
                    <CardMedia
                      component="img"
                      height="300"
                      image={projectData?.pictureList[0]?.pictureUrl ?? PlaceholderImg}
                      alt="Paella dish"
                      onClick={() => {
                        setShowImagePreview(true);
                      }}
                    />
                    <Box sx={{ pb: 1,  pt: 1.5,  p: 2 }}  >
                      <Grid container>
                        <Grid size={{ xs: 12, md: 6 }}>
                          <ListItemText
                            primary={projectData?.projectDetails?.projectName}
                            // secondary={TEXT_PROJECTS}
                            secondary={TEXT_PROJECT}
                          />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                          <Stack sx={{ justifyContent: "flex-end", alignItems: "center" }} direction={"row"} spacing={1}>
                            <Button
                              loading={showFollowLoader}
                              variant="outlined"
                              onClick={() => {
                                projectData?.followDetails?.isFollowing
                                  ? setShowConformationModal("follow")
                                  : changeFollowStatus(true);
                              }}>
                              {projectData?.followDetails?.isFollowing
                                ? BUTTON_UNFOLLOW
                                : BUTTON_FOLLOW}
                            </Button>

                            <Button
                              variant="outlined"
                              onClick={() => {
                                addProjectToUserProfile();
                              }}>
                              {TEXT_ADD_TO_PROFILE}
                            </Button>

                            <IconButton
                              aria-label="settings"
                              onClick={(event) => setMoreMenuAnchorEl(event.currentTarget)}>
                              <MoreVertIcon />
                            </IconButton>
                          </Stack>
                        </Grid>
                      </Grid>
                      {projectData?.memberList?.length > 0 && (
                        <Stack sx={{ gap: 1,  justifyContent: "space-between", alignItems: "center"  }} direction={"row"} >
                          <Stack
                            style={{ width: "100%", scrollbarWidth: "none", overflow: "auto" }}
                            direction={"row"}
                            gap={1}>
                            {projectData?.memberList?.map((member, index) => (
                              <Avatar
                                key={index}
                                src={member.pictureUrl}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setShowMemberList(true);
                                }}
                              />
                            ))}
                          </Stack>
                          <Stack>
                            <IconButton
                              onClick={() => {
                                setShowMemberList(true);
                              }}>
                              <KeyboardArrowRightIcon />
                            </IconButton>
                          </Stack>
                        </Stack>
                      )}
                    </Box>
                    <Tabs
                      sx={{ minHeight: "30px" }}
                      textColor="primary"
                      indicatorColor="primary"
                      value={activeTab}
                      onChange={(event, newTab) => setActiveTab(newTab)}
                      variant="scrollable"
                      scrollButtons="auto">
                      {mainTabMenuList.map(
                        (tab, index) =>
                          tab && <Tab key={index} value={tab.label} label={tab?.translateLabel} />
                      )}
                    </Tabs>
                  </Card>
                </Grid>

                <Grid
                  size={{
                    xs: 12,
                    md: 4
                  }}>
                  <ProjectAboutSection
                    projectDetails={projectData?.projectDetails}
                    onProjectDetailsSaveSuccessfully={onProjectDetailsSaveSuccessfully}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 8
                  }}>
                  {pathname.includes("proxySite") &&
                    (activeTab === "posts" ||
                      activeTab === "companies" ||
                      activeTab === "products" ||
                      activeTab === "photos") ? (
                    <SignInCard />
                  ) : (
                    <>
                      {activeTab === "posts" && (
                        <ProjectPostsSection id={id} scrollId={scrollTargetId} />
                      )}
                      {activeTab === "companies" && (
                        <ProjectCompanySection id={id} scrollId={scrollTargetId} />
                      )}
                      {activeTab === "products" && (
                        <ProjectProductSection id={id} scrollId={scrollTargetId} />
                      )}
                      {activeTab === "photos" && (
                        <ProjectPhotosSection
                          id={id}
                          scrollId={scrollTargetId}
                          photos={projectData?.pictureList ?? []}
                          isLoading={imageDataLoading}
                          getUpdatedPhotos={getUpdatedPhotos}
                          projectDetails={projectData?.projectDetails}
                        />
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </Box>
          )}
        </Card>
      </Box>

      {showImagePreview && (
        <PictureViewer
          isOpen={showImagePreview}
          onClose={() => {
            setShowImagePreview(false);
          }}
          src={projectData?.pictureList?.[0]?.pictureUrl ?? PlaceholderImg}
        />
      )}

      {showSendInChatModal && (
        <SendInChatModal
          isOpen={showSendInChatModal}
          onClose={() => {
            setShowSendInChatModal(false);
          }}
          fromTo="Project"
          title={projectData?.projectDetails?.projectName}
          imageUrl={projectData?.pictureList?.[0]?.pictureUrl ?? PlaceholderImg}
        />
      )}

      {moreMenuAnchorEl && (
        <Menu
          anchorEl={moreMenuAnchorEl}
          open={Boolean(moreMenuAnchorEl)}
          onClose={() => setMoreMenuAnchorEl(null)}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
          {moreMenuList.map((item, index) =>
            item ? (
              <MenuItem
                onClick={() => {
                  if (item.label === "Share") {
                    onShareClick();
                  } else if (item.label === "Send in Chat") {
                    onSendChatClick();
                  } else if (item.label === "Report") {
                    handleOpenReportModal();
                  } else if (item.label === "Add Project Picture") {
                    fileInputRef.current.click();
                  } else {
                    setMoreMenuAnchorEl(null);
                  }
                  setMoreMenuAnchorEl(null);
                }}
                style={{ color: item.label === "Report" ? BIRed : "#083DB8" }}
                key={index}
                dense>
                {item.translateLabel}
              </MenuItem>
            ) : (
              <></>
            )
          )}
        </Menu>
      )}

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileSelect}
        accept="image/*"
        multiple
      />

      {showConformationModal === "follow" || showConformationModal === "worked" ? (
        <DeleteConfirmation
          open={true}
          onClose={() => setShowConformationModal(null)}
          headerText={
            showConformationModal === "follow"
              ? TEXT_UNFOLLOW_PROJECT_PAGE
              : TEXT_DELETE_MODAL_DESC2
          }
          onBadgeClick={() => {
            showConformationModal === "follow" && changeFollowStatus(false);
            setShowConformationModal(null);
          }}
          actionBtnText={showConformationModal === "follow" ? TEXT_YES : BUTTON_REMOVE}
        />
      ) : (
        <></>
      )}

      {showMemberList && (
        <MemberList
          isOpen={showMemberList}
          onClose={() => setShowMemberList(false)}
          members={projectData?.memberList ?? []}
          from={"project-profile"}
          setShowbtnLoader={setShowMemberBtnLoader}
          showBtnLoader={showMemberBtnLoader}
          setProjectData={setProjectData}
        />
      )}
    </>
  );
};

export default ProjectProfile;

